
import { Component, Prop, Vue } from "vue-property-decorator";
import { getPalettes } from "../service/PaletteService";
import { getEscutcheons } from "../service/EscutcheonService";
import { VisualConfModel } from "../generator/visual/VisualConfModel";

@Component
export default class VisualConf extends Vue {
  @Prop() value!: VisualConfModel;

  private paletteOptions = getPalettes();
  private escutcheonOptions = getEscutcheons();

  update(): void {
    this.$emit("input", this.value);
  }
}
